import { render, staticRenderFns } from "./changePasswd.vue?vue&type=template&id=4aefac04&"
import script from "./changePasswd.vue?vue&type=script&lang=js&"
export * from "./changePasswd.vue?vue&type=script&lang=js&"
import style0 from "./changePasswd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports